// 管理側イベント管理エントリーポイント
// 各サブ画面（EventCreate / EventList / EventAnketoMan）が独自に AdminEventTabs を持つため、
// この画面は既定のタブ（イベント作成）へリダイレクトするだけにする。
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const EventMenu = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/event/create", { replace: true });
  }, [navigate]);

  return null;
};

export default EventMenu;
